const lenisSettings = {
	duration: 1.2,
	easing: ( t ) => ( t === 1 ? 1 : 1 - Math.pow( 2, -10 * t ) ),
	direction: 'vertical',
	gestureDirection: 'vertical',
	smooth: true,
	smoothTouch: false,
	wheelMultiplier: 1.2,
	touchMultiplier: 0.2,
	// mouseMultiplier: 0.2,
	inifinite: false
};
const lenis = new Lenis( lenisSettings );
lenis.on( 'scroll', ( e ) => {
	// console.log(e)
});
function raf( time ) {
	lenis.raf( time );
	requestAnimationFrame( raf );
}
requestAnimationFrame( raf );

function toggleScroll( isScroll = true ) {
	if ( isScroll ) {
		lenis.start();
	} else {
		lenis.stop();
	}
}

const controller = new ScrollMagic.Controller();

const sceneSlogan = new ScrollMagic.Scene({
	triggerElement: '.banner-object',
	triggerHook: 'onLeave',
	duration: '100%'
})
	.setTween( '.banner-slogan', 0.5, {
		ease: Linear.easeNone,
		top: '-=100%',
		scale: 2
	})
	.addTo( controller );
const sceneLogo = new ScrollMagic.Scene({
	triggerElement: '.banner-object',
	triggerHook: 'onLeave',
	duration: '100%'
})
	.setTween( '.banner-logo', 0.5, {
		ease: Linear.easeNone,
		top: '+=50%',
		scale: 2,
		opacity: 0.5
	})
	.addTo( controller );

const sceneLeaf1 = new ScrollMagic.Scene({
	triggerElement: '.banner-object',
	triggerHook: 'onLeave',
	duration: '100%'
})
	.setTween( '#leaf-1', 0.5, {
		ease: Linear.easeNone,
		left: '-=30%',
		top: '+=10%',
		scale: 2
	})
	// .addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
	.addTo( controller );
const sceneLeaf2 = new ScrollMagic.Scene({
	triggerElement: '.banner-object',
	triggerHook: 'onLeave',
	duration: '100%'
})
	.setTween( '#leaf-2', 0.5, {
		ease: Linear.easeNone,
		left: '-=10%',
		scale: 2
	})
	.addTo( controller );
const sceneLeaf3 = new ScrollMagic.Scene({
	triggerElement: '.banner-object',
	triggerHook: 'onLeave',
	duration: '100%'
})
	.setTween( '#leaf-3', 0.5, {
		ease: Linear.easeNone,
		left: '+=15%',
		top: '+=8%',
		scale: 2
	})
	.addTo( controller );
const sceneLime1 = new ScrollMagic.Scene({
	triggerElement: '.banner-object',
	triggerHook: 'onLeave',
	duration: '100%'
})
	.setTween( '#lime-1', 0.5, {
		ease: Linear.easeNone,
		left: '-=5%',
		top: '-=50%',
		scale: 1.3
	})
	.addTo( controller );
const sceneCinnamon1 = new ScrollMagic.Scene({
	triggerElement: '.banner-object',
	triggerHook: 'onLeave',
	duration: '100%'
})
	.setTween( '#cinnamon-1', 0.5, {
		ease: Linear.easeNone,
		left: '-=20%',
		top: '+=30%',
		scale: 1.3
	})
	.addTo( controller );
const sceneApple1 = new ScrollMagic.Scene({
	triggerElement: '.banner-object',
	triggerHook: 'onLeave',
	duration: '100%'
})
	.setTween( '#apple-1', 0.5, {
		ease: Linear.easeNone,
		left: '+=40%',
		top: '-=40%',
		scale: 1.4
	})
	.addTo( controller );
const scenePear1 = new ScrollMagic.Scene({
	triggerElement: '.banner-object',
	triggerHook: 'onLeave',
	duration: '100%'
})
	.setTween( '#pear-1', 0.5, {
		ease: Linear.easeNone,
		left: '+=40%',
		top: '+=20%',
		scale: 1.6
	})
	.addTo( controller );


// document.onreadystatechange = function() {
// 	document.querySelector( 'body' ).classList.add( 'no-scroll' );
// 	toggleScroll( false );
// 	if (document.readyState === 'complete') {
// 		document.querySelector( 'body' ).classList.remove( 'no-scroll' );
// 		toggleScroll( true );
// 		const catalogList = document.querySelectorAll( '.catalog-item model-viewer' );
// 		catalogList.forEach( ( item, i ) => {
// 			setTimeout( function() {
// 				item.setAttribute( 'loading', 'lazy' );
// 			}, i * 500 + 2000 );
// 		});
// 	}
// };

/* - - - - - - - - - - - - - -       open fancybox link       - - - - - - - - - - - - - - - */
function initFancyboxLink( link ) {
	$.fancybox.open({
		src: link,
		topRatio: 0,
		closeExisting: true,
		animationEffect: 'fade',
		touch: false,
		autoFocus: false,
		buttons: [
			'slideShow',
			'close'
		],
		smallBtn: true,
		btnTpl: {
			smallBtn:
				'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
				'<span class="icon icon-i-close"></span>' +
				'</button>'
		},
		scrolling: 'hidden',
		helpers: {
			overlay: {
				locked: true
			}
		},
		afterShow: function() {
			toggleScroll( false );
		},
		afterClose: function() {
			toggleScroll( true );
		}
	});
}

$( document ).ready( function() {

	function anchor() {
		const str = document.cookie.split( '; ' );
		const cookie = {};
		for ( let i = 0; i < str.length; i++ ) {
			const cur = str[ i ].split( '=' );
			cookie[ cur[ 0 ] ] = cur[ 1 ];
		}
		if ( cookie.isPreloader === 'false' ) {
			if ( window.location.hash ) {
				$( 'html, body' ).animate({ scrollTop: $( window.location.hash ).offset().top }, 500 );
			}
		}
	}
	if ( window.location.hash ) {
		anchor();
	}

	/* - - - - - - - - - - - - - -       normalize scroll       - - - - - - - - - - - - - - - */
	$( document ).on( 'wheel mousewheel DOMMouseScroll touchmove', '.js-normal-scroll, .fancybox-slide', function( e ) {
		e.stopPropagation();
	});
	$( document ).on( 'wheel mousewheel DOMMouseScroll touchmove', '.js-normal-scroll-tablet', function( e ) {
		if ( window.matchMedia( '(max-width: 1199px)' ).matches ) {
			e.stopPropagation();
		}
	});

	/* - - - - - - - - - - - - - -       init inputmask       - - - - - - - - - - - - - - - */
	// $( '[type="tel"]' ).inputmask( '+38 (999) 999 99 99' );

	/* - - - - - - - - - - - - - -       init fancybox       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '[data-fancybox]', function( e ) {
		e.preventDefault();
		const link = $( this ).attr( 'href' );
		initFancyboxLink( link );
		$( 'html, body' ).removeClass( 'no-scroll' );
		toggleScroll( true );
		$( '.overflow' ).removeClass( 'show' );
	});

	/* - - - - - - - - - - - - - -       menu toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-menu-toggle', function() {
		if ( !$( this ).hasClass( 'active' ) ) {
			$( this ).addClass( 'active' );
			$( '.top-menu' ).addClass( 'show' );
			$( 'html, body' ).addClass( 'no-scroll' );
			toggleScroll( false );
		} else {
			$( this ).removeClass( 'active' );
			$( '.top-menu' ).removeClass( 'show' );
			$( 'html, body' ).removeClass( 'no-scroll' );
			toggleScroll( true );
		}
	});

	/* - - - - - - - - - - - - - -       lang toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-lang li.active', function() {
		const $parent = $( this ).closest( '.lang' );
		if ( window.matchMedia( '(min-width: 1200px)' ).matches ) {
			if ( !$parent.hasClass( 'show' ) ) {
				$parent.addClass( 'show' );
			} else {
				$parent.removeClass( 'show' );
			}
		}
	});

	/* - - - - - - - - - - - - - -       about tip close       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-about-tip-close', function() {
		const $parent = $( this ).closest( '.about-img__tip' );
		if ( !$parent.hasClass( 'show' ) ) {
			$( '.about-img__tip' ).removeClass( 'show' );
			$parent.addClass( 'show' );
		} else {
			$parent.removeClass( 'show' );
		}
	});
	$( document ).on( 'click', function( e ) {
		if ( $( e.target ).closest( '.about-img__tip' ).length ) {
			return;
		}
		$( '.about-img__tip' ).removeClass( 'show' );
	});
	$( window ).on( 'resize', function() {
		if ( window.matchMedia( '(min-width: 1200px)' ).matches ) {
			$( '.about-img__tip' ).removeClass( 'show' );
		}
	});

	/* - - - - - - - - - - - - - -       add zero       - - - - - - - - - - - - - - - */
	function addZeros( n ) {
		return ( n < 10 ) ? '0' + n : n;
	}

	/* - - - - - - - - - - - - - -       scroll catalog thumb       - - - - - - - - - - - - - - - */
	function scrollCatalogThumbs( index ) {
		const $thumbs = $( '.catalog-thumb' ),
			$boxCurrent = $thumbs.find( '.catalog-thumb__box' ).eq( index ),
			$boxPrev = $thumbs.find( '.catalog-thumb__box.active' );
		let center = $( window ).innerWidth() / 2,
			cupLeft = $boxCurrent.position().left,
			widthBig = $boxPrev.innerWidth(),
			widthDiff = $boxPrev.innerWidth() - $boxCurrent.innerWidth(),
			prevIndex = $boxPrev.index(),
			nextIndex = $boxCurrent.index(),
			cupCenter = ( prevIndex < nextIndex ) ? cupLeft - widthDiff + widthBig / 2 : cupLeft + widthBig / 2,
			posLeft = cupCenter - center + $thumbs.scrollLeft();
		$thumbs.animate({ scrollLeft: posLeft }, 500 );
	}

	// const modelViewer = document.querySelector( 'model-viewer#cup' );
	// modelViewer.addEventListener( 'load', () => {
	// 	const material = modelViewer.model.materials[ 1 ];
	// 	const createAndApplyTexture = async (channel, src) => {
	// 		const texture = await modelViewer.createTexture(src);
	// 		material.pbrMetallicRoughness[channel].setTexture(texture);
	// 	};
	// 	createAndApplyTexture( 'baseColorTexture', 'img/texture/1000_ночей_Basecolor.jpg' );
	// });

	/* - - - - - - - - - - - - - -       init catalog slider       - - - - - - - - - - - - - - - */
	function catalogSliderBg( $catalogSliderBg ) {
		const modelViewerCatalog = document.querySelector( '.catalog-img model-viewer' );
		// modelViewerCatalog.addEventListener('load', () => {
		// 	const sym = Symbol('primitives')
		// 	console.log(modelViewerCatalog.model)
		// 	console.log(modelViewerCatalog.availableVariants)
		// 	console.log(modelViewerCatalog.model.getMaterialByName('Cup_izabella'))
		// 	// const [material] = modelViewerCatalog.model.materials;
		// 	// material.pbrMetallicRoughness.setBaseColorFactor('#ff0000');
		// });
		$catalogSliderBg.on( 'init', function() {
			const numberTexture = parseInt( $( '.js-catalog-slider-bg .catalog-item.current' ).attr( 'data-number-texture' ) );
			modelViewerCatalog.variantName = numberTexture;
		});
		$catalogSliderBg.slick({
			infinite: false,
			arrows: false,
			dots: false,
			slidesToScroll: 1,
			slidesToShow: 1,
			swipe: false,
			swipeToSlide: false,
			// touchMove: false,
			speed: 500,
			// autoplay: true,
			// autoplaySpeed: 5000,
			cssEase: 'linear',
			fade: true,
			asNavFor: '.js-catalog-slider'
		}).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
			const time = 500,
				stepTime = 10,
				deg = 360,
				src = $catalogSliderBg.find( '.catalog-item[data-slick-index="' + nextSlide + '"] .catalog-box' ).attr( 'data-texture' );
			let stepDeg = 0;
			$catalogSliderBg.find( '.catalog-item' ).removeClass( 'current' );
			$catalogSliderBg.find( '.catalog-item[data-slick-index="' + nextSlide + '"]' ).addClass( 'current' );
			// const material = modelViewerCatalog.model.materials[ 1 ];
			// const createAndApplyTexture = async (channel, src) => {
			// 	const texture = await modelViewerCatalog.createTexture(src);
			// 	material.pbrMetallicRoughness[channel].setTexture(texture);
			// };
			// setTimeout( function() {
			// 	createAndApplyTexture( 'baseColorTexture', src );
			// }, 0 );
			const numberTexture = parseInt( $( '.js-catalog-slider-bg .catalog-item.current' ).attr( 'data-number-texture' ) );
			setTimeout( function() {
				modelViewerCatalog.variantName = numberTexture;
			}, 200 );
			if ( currentSlide < nextSlide ) {
				const rotate = setInterval( function() {
					stepDeg += deg / ( time / stepTime );
					if ( stepDeg > deg ) {
						stepDeg = deg;
						clearInterval( rotate );
					}
					$( '.catalog-img model-viewer' )[ 0 ].orientation = `0deg 0deg ${ stepDeg }deg`;
					$( '.catalog-img model-viewer' )[ 0 ].orientation = `0deg 0deg ${ stepDeg }deg`;
				}, stepTime );
			} else if ( currentSlide > nextSlide ) {
				stepDeg = deg;
				const rotate = setInterval( function() {
					stepDeg -= deg / ( time / stepTime );
					if ( stepDeg < 0 ) {
						stepDeg = 0;
						clearInterval( rotate );
					}
					$( '.catalog-img model-viewer' )[ 0 ].orientation = `0deg 0deg ${ stepDeg }deg`;
					$( '.catalog-img model-viewer' )[ 0 ].orientation = `0deg 0deg ${ stepDeg }deg`;
				}, stepTime );
			}
			$catalogSliderBg.find( '.catalog-item' ).each( ( i, item ) => {
				if ( i > nextSlide ) {
					$( item ).removeClass( 'show' );
				} else {
					$( item ).addClass( 'show' );
				}
			});
		});
	}
	function catalogSlider( $catalogSlider ) {
		const $parent = $catalogSlider.closest( '.catalog' ),
			$counter = $parent.find( '.catalog-slider__counter' ),
			$thumb = $parent.find( '.catalog-thumb' );
		$catalogSlider.on( 'init reInit afterChange', function( event, slick, currentSlide ) {
			$counter.find( '.current' ).text( addZeros( slick.slickCurrentSlide() + 1 ) );
			$counter.find( '.total' ).text( addZeros( slick.slideCount ) );
			// if ( currentSlide ) {
			// 	if ( currentSlide < slick.slideCount ) {
			// 		$catalogSlider.find( '.catalog-item[data-slick-index="' + ( currentSlide + 1 ) + '"] model-viewer' ).attr( 'loading', 'eager' );
			// 	}
			// 	if ( currentSlide + 1 < slick.slideCount ) {
			// 		$catalogSlider.find( '.catalog-item[data-slick-index="' + ( currentSlide + 2 ) + '"] model-viewer' ).attr( 'loading', 'eager' );
			// 	}
			// } else {
			// 	$catalogSlider.find( '.catalog-item[data-slick-index="0"] model-viewer' ).attr( 'loading', 'eager' );
			// 	$catalogSlider.find( '.catalog-item[data-slick-index="1"] model-viewer' ).attr( 'loading', 'eager' );
			// }
		});
		$catalogSlider.slick({
			infinite: false,
			arrows: true,
			dots: false,
			slidesToScroll: 1,
			slidesToShow: 1,
			swipe: false,
			swipeToSlide: false,
			// touchMove: false,
			speed: 500,
			// autoplay: true,
			// autoplaySpeed: 5000,
			cssEase: 'linear',
			fade: true,
			appendArrows: $( '.catalog-slider__navigate' ),
			asNavFor: '.js-catalog-slider-bg'
		}).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
			const count = slick.slideCount;
			const time = 500,
				stepTime = 10,
				deg = 360;
			let stepDeg = 0;
			scrollCatalogThumbs( nextSlide );
			$catalogSlider.find( '.catalog-item' ).removeClass( 'current' );
			$catalogSlider.find( '.catalog-item[data-slick-index="' + nextSlide + '"]' ).addClass( 'current' );
			$catalogSlider.find( '.catalog-box__text' ).removeClass( 'show' );
			$catalogSlider.find( '.catalog-box__desc' ).removeClass( 'show' );
			$thumb.find( '.catalog-thumb__box' ).removeClass( 'active' );
			$thumb.find( '.catalog-thumb__box[data-slide="' + $catalogSlider.find( '.catalog-item.current' ).attr( 'data-slide' ) + '"]' ).addClass( 'active' );
			$counter.find( '.total' ).text( addZeros( count ) );
			if ( currentSlide < nextSlide ) {
				setTimeout( function() {
					$counter.find( '.current' ).text( addZeros( nextSlide ) );
				}, 250 );
				// const rotate = setInterval( function() {
				// 	stepDeg += deg / ( time / stepTime );
				// 	if ( stepDeg > deg ) {
				// 		stepDeg = deg;
				// 		clearInterval( rotate );
				// 	}
				// 	$catalogSlider.find( '.catalog-item[data-slick-index="' + currentSlide + '"]' ).find( 'model-viewer' )[ 0 ].orientation = `0deg 0deg ${ stepDeg }deg`;
				// 	$catalogSlider.find( '.catalog-item[data-slick-index="' + nextSlide + '"]' ).find( 'model-viewer' )[ 0 ].orientation = `0deg 0deg ${ stepDeg }deg`;
				// }, stepTime );
			} else if ( currentSlide > nextSlide ) {
				stepDeg = deg;
				setTimeout( function() {
					$counter.find( '.current' ).text( addZeros( currentSlide ) );
				}, 250 );
				// const rotate = setInterval( function() {
				// 	stepDeg -= deg / ( time / stepTime );
				// 	if ( stepDeg < 0 ) {
				// 		stepDeg = 0;
				// 		clearInterval( rotate );
				// 	}
				// 	$catalogSlider.find( '.catalog-item[data-slick-index="' + currentSlide + '"]' ).find( 'model-viewer' )[ 0 ].orientation = `0deg 0deg ${ stepDeg }deg`;
				// 	$catalogSlider.find( '.catalog-item[data-slick-index="' + nextSlide + '"]' ).find( 'model-viewer' )[ 0 ].orientation = `0deg 0deg ${ stepDeg }deg`;
				// }, stepTime );
			}
			$catalogSlider.find( '.catalog-item' ).each( ( i, item ) => {
				if ( i > nextSlide ) {
					$( item ).removeClass( 'show' );
				} else {
					$( item ).addClass( 'show' );
				}
			});
		}).on( 'afterChange', function( event, slick, currentSlide ) {
			// if ( slick.currentSlide === slick.slideCount - slick.options.slidesToShow ) {
			// 	$catalogSlider.slick( 'slickPause' );
			// }
		});
	}
	function playCatalogSlider( $slider ) {
		const top = $( window ).scrollTop(),
			sliderHeight = $slider.innerHeight(),
			posStart = $slider.offset().top,
			windowHeight = $( window ).innerHeight();
		if ( top > posStart - windowHeight && top < posStart + sliderHeight ) {
			const $slick = $slider.get( 0 ).slick;
			if ( $slick.currentSlide < $slick.slideCount - $slick.options.slidesToShow ) {
				$slider.slick( 'slickPlay' );
			}
		}
	}
	if ( $( '.js-catalog-slider' ).length ) {
		$( '.js-catalog-slider' ).each( function() {
			const $slider = $( this );
			catalogSlider( $slider );
			// $slider.slick( 'slickPause' );
			//
			// playCatalogSlider( $slider );
			// $( window ).on( 'scroll', function() {
			// 	playCatalogSlider( $slider );
			// });
		});
		$( '.js-catalog-slider-bg' ).each( function() {
			const $slider = $( this );
			catalogSliderBg( $slider );
		});
	}

	/* - - - - - - - - - - - - - -       catalog text toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-catalog-text-open', function() {
		const $parent = $( this ).closest( '.catalog-box' );
		$parent.find( '.catalog-box__desc' ).removeClass( 'show' );
		$parent.find( '.catalog-box__text' ).addClass( 'show' );
	});
	$( document ).on( 'click', '.js-catalog-text-close', function() {
		const $parent = $( this ).closest( '.catalog-box' );
		$parent.find( '.catalog-box__text' ).removeClass( 'show' );
	});

	/* - - - - - - - - - - - - - -       catalog desc toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-catalog-desc-open', function() {
		const $parent = $( this ).closest( '.catalog-box' );
		$parent.find( '.catalog-box__text' ).removeClass( 'show' );
		$parent.find( '.catalog-box__desc' ).addClass( 'show' );
	});
	$( document ).on( 'click', '.js-catalog-desc-close', function() {
		const $parent = $( this ).closest( '.catalog-box' );
		$parent.find( '.catalog-box__desc' ).removeClass( 'show' );
	});

	/* - - - - - - - - - - - - - -       catalog slide       - - - - - - - - - - - - - - - */
	// function counterCatalogSlider() {
	// 	const $slider = $( '.catalog-slider' ),
	// 		$counter = $( '.catalog-slider__counter' ),
	// 		currentIndex = $slider.find( '.catalog-item.current' ).index() + 1,
	// 		count = $slider.find( '.catalog-item' ).length;
	// 	$counter.find( '.total' ).text( addZeros( count ) );
	// 	setTimeout( function() {
	// 		$counter.find( '.current' ).text( addZeros( currentIndex ) );
	// 	}, 250 );
	// }
	// if ( $( '.catalog-slider' ).length ) {
	// 	counterCatalogSlider();
	// }
	// $( document ).on( 'click', '.js-catalog-prev', function() {
	// 	const $slider = $( '.catalog-slider' ),
	// 		$thumb = $( '.catalog-thumb' ),
	// 		currentIndex = $slider.find( '.catalog-item.current' ).index(),
	// 		count = $slider.find( '.catalog-item' ).length;
	// 	if ( currentIndex > 0 ) {
	// 		const nextIndex = currentIndex - 1,
	// 			time = 500,
	// 			stepTime = 10,
	// 			deg = 360;
	// 		let stepDeg = deg;
	// 		$slider.find( '.catalog-item' ).removeClass( 'current' );
	// 		$slider.find( '.catalog-item' ).eq( nextIndex ).addClass( 'current' );
	// 		$thumb.find( '.catalog-thumb__box' ).removeClass( 'active' );
	// 		$thumb.find( '.catalog-thumb__box[data-slide="' + $slider.find( '.catalog-item.current' ).attr( 'data-slide' ) + '"]' ).addClass( 'active' );
	// 		counterCatalogSlider();
	//
	// 		$slider.find( '.catalog-item' ).each( ( i, item ) => {
	// 			if ( i > nextIndex ) {
	// 				$( item ).removeClass( 'show' );
	// 			} else {
	// 				$( item ).addClass( 'show' );
	// 			}
	// 		});
	//
	// 		const rotate = setInterval( function() {
	// 			stepDeg -= deg / ( time / stepTime );
	// 			if ( stepDeg < 0 ) {
	// 				stepDeg = 0;
	// 				clearInterval( rotate );
	// 			}
	// 			$slider.find( '.catalog-item' ).eq( currentIndex ).find( 'model-viewer' )[0].orientation = `0deg 0deg ${ stepDeg }deg`;
	// 			$slider.find( '.catalog-item' ).eq( nextIndex ).find( 'model-viewer' )[0].orientation = `0deg 0deg ${ stepDeg }deg`;
	// 		}, stepTime );
	// 	}
	// });
	// $( document ).on( 'click', '.js-catalog-next', function() {
	// 	const $slider = $( '.catalog-slider' ),
	// 		$thumb = $( '.catalog-thumb' ),
	// 		currentIndex = $slider.find( '.catalog-item.current' ).index(),
	// 		count = $slider.find( '.catalog-item' ).length;
	// 	if ( currentIndex < count - 1 ) {
	// 		const nextIndex = currentIndex + 1,
	// 			time = 500,
	// 			stepTime = 10,
	// 			deg = 360;
	// 		let stepDeg = 0;
	// 		$slider.find( '.catalog-item' ).eq( nextIndex ).addClass( 'current' );
	// 		$slider.find( '.catalog-item' ).eq( currentIndex ).removeClass( 'current' );
	// 		$thumb.find( '.catalog-thumb__box' ).removeClass( 'active' );
	// 		$thumb.find( '.catalog-thumb__box[data-slide="' + $slider.find( '.catalog-item.current' ).attr( 'data-slide' ) + '"]' ).addClass( 'active' );
	// 		counterCatalogSlider();
	//
	// 		$slider.find( '.catalog-item' ).each( ( i, item ) => {
	// 			if ( i > nextIndex ) {
	// 				$( item ).removeClass( 'show' );
	// 			} else {
	// 				$( item ).addClass( 'show' );
	// 			}
	// 		});
	//
	// 		const rotate = setInterval( function() {
	// 			stepDeg += deg / ( time / stepTime );
	// 			if ( stepDeg > deg ) {
	// 				stepDeg = deg;
	// 				clearInterval( rotate );
	// 			}
	// 			$slider.find( '.catalog-item' ).eq( currentIndex ).find( 'model-viewer' )[0].orientation = `0deg 0deg ${ stepDeg }deg`;
	// 			$slider.find( '.catalog-item' ).eq( nextIndex ).find( 'model-viewer' )[0].orientation = `0deg 0deg ${ stepDeg }deg`;
	// 		}, stepTime );
	// 	}
	// });

	/* - - - - - - - - - - - - - -       input validate       - - - - - - - - - - - - - - - */
	function setInput() {
		$( 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea' ).each( function() {
			const $parent = $( this ).closest( '.form-group' );
			if ( $( this ).val() !== '' ) {
				$parent.addClass( 'filled' );
			}
		});
	}
	setInput();
	$( 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea' ).on( 'focus', function() {
		const $parent = $( this ).closest( '.form-group' );
		$parent.addClass( 'filled' );
	});
	$( 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea' ).on( 'blur', function() {
		$( 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea' ).each( function() {
			const $parent = $( this ).closest( '.form-group' );
			if ( $( this ).val() === '' && !$( this ).is( ':focus' ) ) {
				$parent.removeClass( 'filled' );
			}
		});
	});
	$( 'textarea' ).on( 'input', function() {
		const $parent = $( this ).closest( '.form-group' );
		if ( $( this ).val() !== '' ) {
			$parent.addClass( 'filled' );
		} else {
			$parent.removeClass( 'filled' );
		}
	});

	$( document ).on( 'click', '.js-scroll-to', function( e ) {
		e.preventDefault();
		const link = $( this ).attr( 'href' );
		if ( !link.indexOf( '#' ) ) {
			if ( $( link ).length ) {
				$( 'html, body' ).animate({ scrollTop: $( link ).offset().top }, 500 );
				$( '.top-menu' ).removeClass( 'show' );
				$( '.menu-toggle' ).removeClass( 'active' );
				$( 'html, body' ).removeClass( 'no-scroll' );
				toggleScroll( true );
			}
		} else {
			const pathname = window.location.pathname,
				origin = window.location.origin;
			const reg = /\/(\w{2})\//;
			if ( reg.exec( pathname ) ) {
				const lang = reg.exec( pathname )[0].split('/')[1];
				window.location.href = origin + '/' + lang + link;
			} else {
				window.location.href = window.location.origin + link;
			}
		}
	});

	// function fixedCatalog() {
	// 	console.log($( window ).scrollTop())
	// }
	// $( window ).on( 'scroll', fixedCatalog );

	let tlSlider = gsap.timeline({
		scrollTrigger: {
			trigger: '.catalog-slider',
			start: 'top top',
			end: 'bottom bottom',
			// trigger: '.banner-logo',
			// start: 'top top',
			// endTrigger: '.about-inner .title',
			// end: 'top top',
			scrub: true,
			invalidateOnRefresh: true,
			onEnter: () => {
				// console.log('onEnter');
				if ( window.matchMedia( '(min-width: 1200px)' ).matches ) {
					toggleScroll( false );
				}
			},
			onLeave: () => {
				// console.log('onLeave');
				if ( $( 'html' ).hasClass( 'lenis-stopped' ) ) {
					toggleScroll( true );
				}
			},
			onEnterBack: () => {
				// console.log('onEnterBack');
				// toggleScroll( false );
			}
		}
	});
	$( '.catalog-slider' ).on( 'mousewheel', function() {
		if ( $( 'html' ).hasClass( 'lenis-stopped' ) ) {
			toggleScroll( true );
		}
	});

});
